export default __webpack_public_path__ + "static/media/SWT0280.34I-26771_-16382_0.f78a1b5c.jpg";